import * as React from "react";
import { Context } from "./_context";
export const VigationMenuAfterpayIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M21.25 17.5a.25.25 0 0 1 .25.25v2.5a.25.25 0 0 1-.25.25H2.75a.25.25 0 0 1-.25-.25v-2.5a.25.25 0 0 1 .25-.25h18.5Zm0-7a.25.25 0 0 1 .25.25v2.5a.25.25 0 0 1-.25.25H2.75a.25.25 0 0 1-.25-.25v-2.5a.25.25 0 0 1 .25-.25h18.5Zm0-7a.25.25 0 0 1 .25.25v2.5a.25.25 0 0 1-.25.25H2.75a.25.25 0 0 1-.25-.25v-2.5a.25.25 0 0 1 .25-.25h18.5Z", fill: "currentColor" }));
  return iconset[size];
};
VigationMenuAfterpayIcon.iconId = "d9g2L6";
